import api from "../../../api/axios";

const STATUS_CIM_BASE = "/statuscim";
const DEFAULT_LIMIT = 5000;

export async function getStatusCim({ signal, limit = DEFAULT_LIMIT } = {}) {
  const noCacheHeaders = {
    "Cache-Control": "no-store",
    Pragma: "no-cache",
  };

  const response = await api.get(`${STATUS_CIM_BASE}/listar`, {
    params: { limit, offset: 0, _: Date.now() },
    signal,
    headers: noCacheHeaders,
  });

  const rows = Array.isArray(response?.data?.data) ?response.data.data : [];

  return {
    rows,
  };
}
